import { Helmet } from "react-helmet";
import PlaybackHeader from "./Controls/PlaybackHeader";
import SecondHeader from "../../Header/SecondHeader";
import { useGetAllDevicesQuery } from "../../../Redux/service/Devices";
import { PlaybackProvider, usePlayback } from "../../../context/VideoPlayback";
import GlobalTimeline from "./Controls/GlobalTimeline";
import VideoLayout from "./Controls/VideoLayout";
import AccessDenied from "../../AccessDenied";
import usePermission from "../../../hooks/usePermission";

const buildVehicleOptions = (feeds) => {
  const grouped = {};

  feeds.forEach((feed) => {
    if (!grouped[feed.vehicle]) {
      grouped[feed.vehicle] = [];
    }
    grouped[feed.vehicle].push({
      title: `Channel ${feed.channel}`,
      value: `${feed.vehicle}-${feed.channel}`,
      url: feed.hlsUrl,
    });
  });

  return Object.keys(grouped).map((vehicle) => ({
    title: vehicle,
    value: vehicle,
    children: grouped[vehicle],
  }));
};

const VideoPlayback = () => {
  const { data: vehiclesData, isLoading } = useGetAllDevicesQuery();
  const {
    layoutType,
    setLayoutType,
    isPlaying,
    selectedFeeds,
    setSelectedFeeds,
    selectedValues,
    setSelectedValues,
  } = usePlayback();
  const { view } = usePermission("PLAYBACK");

  const cameraFeeds = [];

  if (!view) {
    return <AccessDenied />;
  }

  if (vehiclesData && vehiclesData.length > 0) {
    vehiclesData.forEach((vehicle) => {
      for (let i = 1; i <= 9; i++) {
        cameraFeeds.push({
          vehicle: vehicle.name || vehicle.id, // adapt based on your API structure
          channel: `c${i}`,
          hlsUrl: "https://test-streams.mux.dev/x36xhzz/x36xhzz.m3u8",
          duration: 620,
        });
      }
    });
  }

  const vehicleOptions = buildVehicleOptions(cameraFeeds);

  const handleLayoutChange = (newLayoutType) => {
    let maxFeeds = 4;
    switch (newLayoutType) {
      case 1:
        maxFeeds = 1;
        break;
      case 2:
        maxFeeds = 4;
        break;
      case 3:
        maxFeeds = 6;
        break;
      case 4:
        maxFeeds = 9;
        break;
      case 5:
        maxFeeds = 8;
        break;
      default:
        maxFeeds = 4;
        break;
    }

    // Trim extra selected feeds if needed
    setSelectedFeeds((prev) => {
      const trimmed = prev.slice(0, maxFeeds);
      const trimmedValues = trimmed.map(
        (feed) => `${feed.vehicle}-${feed.channel}`
      );
      setSelectedValues(trimmedValues);
      return trimmed;
    });
    setLayoutType(newLayoutType);
  };

  return (
    <>
      <Helmet>
        <title>Video Playback</title>
        <meta name="description" content="Users" />
      </Helmet>
      <SecondHeader />
      <PlaybackHeader
        setLayoutType={handleLayoutChange}
        vehicles={vehicleOptions}
        feeds={cameraFeeds}
        setSelectedFeeds={setSelectedFeeds}
        selectedValues={selectedValues}
        isLoading={isLoading}
      />
      <div>
        <VideoLayout
          cameraFeeds={selectedFeeds}
          layoutType={layoutType}
          isPlaying={isPlaying}
        />
      </div>
      <GlobalTimeline />
    </>
  );
};

export default VideoPlayback;
